import React from 'react';
import { Button } from './ui/button';
import { ebookData } from '../mockData';
import { BookOpen, Check } from 'lucide-react';

const EBookSection = () => {
  const handlePurchase = () => {
    window.open(ebookData.purchaseLink, '_blank');
  };

  return (
    <section id="ebook" className="py-16 sm:py-14 sm:py-16 lg:py-20 lg:py-24 bg-black">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16 space-y-4">
            <div className="text-gray-400 font-bold text-sm tracking-widest uppercase">
              Digital Resource
            </div>
            <h2 className="text-4xl md:text-6xl font-black text-white">
              Basketball Recruiting E-BOOK
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              Your complete guide to becoming a college basketball prospect
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center bg-neutral-900 rounded-2xl p-8 md:p-12 border border-neutral-800">
            {/* Image */}
            <div className="relative">
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden">
                <img 
                  src={ebookData.image} 
                  alt={ebookData.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
              </div>
              {/* Book icon overlay */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <div className="bg-gray-400 rounded-full p-6 shadow-2xl">
                  <BookOpen className="w-12 h-12 text-black" />
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="space-y-6">
              <div>
                <h3 className="text-3xl md:text-4xl font-black text-white mb-2">
                  {ebookData.title}
                </h3>
                <p className="text-xl text-gray-400 mb-4">
                  {ebookData.subtitle}
                </p>
                <p className="text-lg text-gray-300 leading-relaxed">
                  {ebookData.description}
                </p>
              </div>

              {/* Features */}
              <div className="space-y-3">
                <div className="text-sm font-bold text-gray-300 uppercase tracking-wider">
                  What You'll Learn:
                </div>
                <ul className="space-y-2">
                  {ebookData.features.map((feature, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <Check className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-300">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Price and CTA */}
              <div className="pt-6 border-t border-neutral-800">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <div className="text-sm text-gray-500 uppercase tracking-wider">Price</div>
                    <div className="text-4xl font-black text-white">{ebookData.price}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-gray-500">Digital Download</div>
                    <div className="text-sm text-gray-400">Instant Access</div>
                  </div>
                </div>
                
                <Button 
                  onClick={handlePurchase}
                  className="w-full bg-gray-400 hover:bg-gray-500 text-black font-bold py-6 text-lg transition-all hover:scale-105"
                >
                  Purchase E-BOOK
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EBookSection;
